/**
 * L'enchaînement de `<StepStage>`, pur : quelle étape est à l'écran, et ce qu'elle fait.
 *
 * Une étape à la fois (« une chose à la fois », le livre, chap. 13) : quand la clé change, celle qui
 * est montrée SORT d'abord ; la nouvelle n'est montée qu'une fois la sortie finie, puis elle ENTRE.
 *  - une nouvelle clé pendant une sortie remplace la cible : la sortie continue, et c'est la dernière
 *    clé demandée qui entre ;
 *  - la clé montrée qui revient pendant une sortie : elle rentre, rien n'est remonté ;
 *  - une nouvelle clé pendant une entrée : la sortie part de là où l'entrée en est ;
 *  - en mouvement réduit (`instant`), la clé est montrée aussitôt, sans sortie ni entrée.
 */

export type StepStagePhase = "idle" | "leaving" | "entering"

export type StepStageState = {
    /** La clé de l'étape à l'écran. */
    shown: string
    /** La clé demandée ; elle diffère de `shown` pendant une sortie. */
    target: string
    phase: StepStagePhase
}

export type StepStageEvent =
    /** La clé demandée par l'appelant, à chaque rendu. */
    | { type: "KEY"; key: string; instant: boolean }
    /** La sortie est finie : la cible peut entrer. */
    | { type: "LEFT" }
    /** L'entrée est finie. */
    | { type: "ENTERED" }

export function initialStepStage(key: string): StepStageState {
    return { shown: key, target: key, phase: "idle" }
}

export function stepStageReducer(state: StepStageState, event: StepStageEvent): StepStageState {
    switch (event.type) {
        case "KEY": {
            if (event.instant) {
                return state.shown === event.key && state.phase === "idle"
                    ? state
                    : { shown: event.key, target: event.key, phase: "idle" }
            }
            if (event.key === state.target) return state
            if (event.key === state.shown) return { ...state, target: event.key, phase: "entering" }
            return { ...state, target: event.key, phase: "leaving" }
        }
        case "LEFT":
            return state.phase === "leaving" ? { shown: state.target, target: state.target, phase: "entering" } : state
        case "ENTERED":
            return state.phase === "entering" ? { ...state, phase: "idle" } : state
    }
}
